<template>
  <div class="btnsContainer">
    <button
      v-for="(item, index) in list"
      :key="item.router"
      :style="current == index ? active : ''"
      class="zui-button"
      @click="onClick(item.router, index)"
    >
      {{ item.text }}
    </button>
  </div>
</template>
<script>
import "./less/button.less";
export default {
  props: {
    list: {
      default: []
    }
  },
  data() {
    return {
      active: {
        color: "#0055ff",
        fontWeight: "700"
      },
      current: 7
    };
  },
  methods: {
    onClick(e, index) {
      this.$emit("click", e);
    }
  },
  watch: {
    $route() {
      if (this.$route.path == "/home") {
        this.current = 6;
      }
      if (this.$route.path.substring(0, 12) == "/information") {
        this.current = 5;
      }
      if (this.$route.path == "/solution") {
        this.current = 4;
      }
      // if (this.$route.path == "/pricing" || this.$route.path == "/open") {
      //   this.current = 4;
      // }
      if (this.$route.path.substring(0, 8) == "/product") {
        this.current = 3;
      }
      if (this.$route.path == "/recruitment") {
        this.current = 2;
      }
      if (this.$route.path.substring(0, 9) == "/download") {
        this.current = 1;
      }
      if (this.$route.path == "/aboutus") {
        this.current = 0;
      }
    }
  }
  //深度监听
  // watch: {
  //   $route: {
  //     handler: function(val, oldVal) {
  //       console.log(val);
  //     },
  //     // 深度观察监听
  //     deep: true
  //   }
  // }
};
</script>



// WEBPACK FOOTER //
// src/components/Button.vue